import { useEffect, useState, Suspense } from "react";
import AppHeader from "@src/components/common/appHeader/AppHeader";
import {
  AccordionGroup,
  Accordion,
  AccordionSummary,
  AccordionDetail,
} from "@src/components/common/accordion/Accordion";
import { getRecommendHallList, IRecommendHallList } from "@src/api/recommend/recommend";
import { convertStringToInteger, HOSTNAME, numberToKorean, isExternalUrl } from "@src/utils";
import { logPageMoveEvent } from "@src/reactGa";
import dayjs from "dayjs";

export const RecommendHallSendStatus = {
  0: "답변 대기",
  1: "답변 완료",
  2: "답변 반려",
};

const MyList = () => {
  const [list, setList] = useState<IRecommendHallList[] | null>(null);

  const getList = async () => {
    try {
      const res = await getRecommendHallList();
      setList(res.data.item);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className="recommend-hall-page recommend-hall-mylist">
      <AppHeader type="stack" title="추천 리스트" actionItems={[{ name: "close" }]} />
      <Suspense>
        <p style={{ padding: "12px 20px 0" }}>총 {list !== null ? list.length : 0}개</p>
        <AccordionGroup isExclusive={false}>
          {list?.map((item, index) => (
            <Accordion key={index} index={index}>
              {({ isOpen, toggleOpen }) => (
                <>
                  <AccordionSummary onClick={toggleOpen} isOpen={isOpen} isShowChevron={false}>
                    <div className="recommend-hall-mylist-summary">
                      <div>
                        <span className="recommend-hall-mylist-date">
                          {dayjs(item.regTsp).format("YYYY.MM.DD HH:mm")}
                        </span>
                        <b>추천 리스트</b>
                        <span className="recommend-hall-mylist-status">
                          {RecommendHallSendStatus[item.isSend]}
                        </span>
                      </div>
                      {item.isSend === 1 && (
                        <button
                          className="btn btn-tiny btn-outline-brown500"
                          onClick={(e) => {
                            e.stopPropagation();
                            logPageMoveEvent({
                              destination_page: `${HOSTNAME}/recommend/hall/${item.uuid}`,
                              content: "홀 추천 리스트",
                            });
                            window.location.href = isExternalUrl(
                              `${HOSTNAME}/recommend/hall/${item.uuid}?hidetop=true`,
                            );
                          }}
                        >
                          추천 리스트 보기
                        </button>
                      )}
                    </div>
                  </AccordionSummary>
                  <AccordionDetail isOpen={isOpen}>
                    <div className="recommend-hall-mylist-detail">
                      <h4>신청 내역</h4>
                      <ul>
                        <li>
                          <b>스타일 : </b>
                          {item.hallStyleTypes ? item.hallStyleTypes.split(";").join(", ") : ""}
                        </li>
                        <li>
                          <b>예식 형태 : </b>
                          {item.weddingType ? item.weddingType.split(";").join(", ") : ""}
                        </li>
                        <li>
                          <b>예식 지역 : </b>
                          <ul>
                            {item.regions.map((region, index) => (
                              <li key={index}>
                                {region.mainRegion} - {region.subRegions.split(", ").join("/")}
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li>
                          <b>예상 보증인원 : </b>
                          {item.expectedMinPerson ? `${item.expectedMinPerson}명` : ""} ~{" "}
                          {item.expectedMaxPerson ? `${item.expectedMaxPerson}명` : ""}
                        </li>
                        <li>
                          <b>식사 형태 : </b>
                          {item.mealType ? item.mealType.split(";").join(", ") : ""}
                        </li>
                        <li>
                          <b>1인당 식사비용 : </b>
                          {item.mealMinPrice ? numberToKorean(item.mealMinPrice) : ""} ~{" "}
                          {item.mealMaxPrice ? numberToKorean(item.mealMaxPrice) : ""}
                        </li>
                        <li>
                          <b>희망 예식일 : </b>
                          <ul>
                            <li>
                              날짜 :{" "}
                              {item.hopeWeddingYearMonths
                                ? item.hopeWeddingYearMonths
                                    .split(";")
                                    .sort(
                                      (a, b) =>
                                        convertStringToInteger(a) - convertStringToInteger(b),
                                    )
                                    .join(", ")
                                : ""}
                            </li>
                            <li>
                              요일 :{" "}
                              {item.hopeWeddingDays ? item.hopeWeddingDays.split(";").join(", ") : ""}
                            </li>
                            <li>
                              시간 :{" "}
                              {item.hopeWeddingTimes
                                ? item.hopeWeddingTimes.split(";").join(", ")
                                : ""}
                            </li>
                          </ul>
                        </li>
                        <li>
                          <b>웨딩홀 결정시 중요한점 : </b>
                          {item.importantFactors}
                        </li>
                      </ul>
                    </div>
                  </AccordionDetail>
                </>
              )}
            </Accordion>
          ))}
        </AccordionGroup>
      </Suspense>
    </div>
  );
};

export default MyList;
